var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header-container"},[_c('div',[(_vm.userInformation)?_c('h1',[_vm._v(_vm._s(_vm.userInformation.firstName)+", van welke test wil jij"),_c('br'),_vm._v("je resultaten zien?")]):_vm._e()])])])}
var staticRenderFns = []

export { render, staticRenderFns }